import React, { useEffect, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import AdminPicker from '../../../components/AdminPicker/AdminPicker'
import { useAuth, useProtectedPage, useSetManager } from '../../../context/AuthContext'
import callAPI from '../../../helpers/callAPI'
import useQueryParams from '../../../hooks/useQueryParams'
import Affiliate from '../../../templates/Affiliate/Affiliate'
import Campaign from '../../../templates/Campaign/Campaign'
import Dollars from '../../../templates/Dollars/Dollars'
import ReportTable from '../../../templates/ReportTable/ReportTable'
import Loading from '../../../templates/UI/Loading/Loading'
import moment from 'moment'

const ReportAffiliateCampaignPickups = ({ showSystemMessage }) => {

    document.title = 'New Campaign Pickups for 30 days'

    let auth = useAuth()
    useProtectedPage(auth.permissions, 'affiliates_top')
    let showManagerDropdown = useSetManager(auth.permissions, 'affiliates_top')

    const { adminId, setAdminId, buildUrl } = useQueryParams()

    const history = useHistory()
    const location = useLocation()
    const [dataLoaded, setDataLoaded] = useState(false)
    const [report, setReport] = useState([])

    useEffect(() => {
        getReport()
    }, [location])

    const getReportOutput = () => {
        let columns = [
            {
                Header: 'ID',
                accessor: 'offer_id',
                Cell: ({ cell: { value } }) => {
                    return <>{value}</>
                },
            },
            {
                Header: 'Campaign',
                accessor: 'offer_name',
                Cell: (tableData) => {
                    return <Campaign oid={tableData.data[tableData.row.index].offer_id} name={tableData.data[tableData.row.index].offer_name} status={tableData.data[tableData.row.index].offer_status_value} />
                },
            },
            {
                Header: 'Affiliate',
                accessor: 'affiliate_name',
                Cell: (tableData) => {
                    return <Affiliate aid={tableData.data[tableData.row.index].affiliate_id} name={tableData.data[tableData.row.index].affiliate_name} priority={tableData.data[tableData.row.index].aff_priority} status={tableData.data[tableData.row.index].affiliate_status_value} />
                },
            },
            {
                Header: <div style={{ textAlign: 'right' }}>Affiliate Earnings</div>,
                accessor: 'earnings',
                className: 'text-right',
                Cell: ({ cell: { value } }) => {
                    return <Dollars value={value} />
                },
            },
            {
                Header: <div style={{ textAlign: 'right' }}>Net Earnings</div>,
                accessor: 'net_earnings',
                className: 'text-right',
                Cell: ({ cell: { value } }) => {
                    return <Dollars value={value} />
                },
            },
            {
                Header: <div style={{ textAlign: 'right' }}>Margin</div>,
                accessor: 'margin',
                className: 'text-right',
                Cell: (tableData) => {
                    return <Link to={`/reports/stats/campaigns?affiliateId=${tableData.data[tableData.row.index].affiliate_id}&campaignId=${tableData.data[tableData.row.index].offer_id}&startDate=${moment().add(-30, 'days').format('YYYY-MM-DD')}&withAvatar=true`} className="text-primary font-weight-bold">
                        <Dollars value={tableData.data[tableData.row.index].margin} />
                    </Link>
                    
                },
            },
        ]

        return (
            <React.Fragment>
                <ReportTable data={report} columns={columns} />
            </React.Fragment>
        )
    }

    const refreshReport = (e) => {
        e.preventDefault()

        let url = buildUrl(`/affiliates/campaignPickups?`)
        history.push(url)
    }

    const getReport = () => {
        setDataLoaded(false)

        let url = buildUrl(`reports/affiliateCampaignPickups?period=Monthly`)

        callAPI(url, 'GET')
            .then((result) => {
                if (result['success'] === true) {
                    setReport(result.report)
                } else if (result['success'] === false) {
                    showSystemMessage('error', result.errors.message)
                }

                setDataLoaded(true)
            })
            .catch((error) => {
                console.log(`Error while fetching new campaign pickups: ${error}`)
                showSystemMessage('error', 'An error occurred while fetching new campaign pickups')
            })
    }

    return (
        <div>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Reports</h1>
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-body p-0">
                            <div className="d-flex p-3">
                                <div className="mr-4 d-flex align-items-center">
                                    <h1 className="mb-h1-dark">New Campaign Pickups for 30 days</h1>
                                </div>
                                {showManagerDropdown && (
                                    <>
                                        <div className="mr-4">
                                            <AdminPicker adminId={adminId} setAdminId={setAdminId} role={['AM_JUNIOR', 'AM_SENIOR', 'AM_JR_TEAMLEAD']} />
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <button onClick={refreshReport} className="btn btn-sm btn-primary">
                                                Refresh Report
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                            {dataLoaded ? report.length === 0 ? <div className="p-3">No stats for the current parameters.</div> : getReportOutput() : <Loading />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReportAffiliateCampaignPickups
